import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HotelChainManagementRoutingModule } from './hotel-chain-management-routing.module';
import { HcaAddComponent } from './hca-add/hca-add.component';
import { HcaDetailsComponent } from './hca-details/hca-details.component';
import { HcaListComponent } from './hca-list/hca-list.component';
import { HcaMainComponent } from './hca-main/hca-main.component';
import { SharedModule } from '../../../../shared/shared.module';
import { HcaManagementService } from '../../../../shared/_services/hca-management.service';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HotelChainManagementRoutingModule
  ],
  providers: [HcaManagementService],
  declarations: [HcaAddComponent, HcaDetailsComponent, HcaListComponent, HcaMainComponent]
})
export class HotelChainManagementModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/hotel-chain-management/hotel-chain-management.module.ts